import { render } from "./search-filter.vue?vue&type=template&id=048f0093"
import script from "./search-filter.vue?vue&type=script&lang=js"
export * from "./search-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__